<div style="padding-top: 2em;" *ngIf="!isLoading" class="loadingDiv">
    <h1 style="color: #424242;font-size: 1em;" *ngIf="data.items.length > 0">Employees with incorrect supervisors: </h1>
    <h1 style="color: #424242;font-size: 1em;" *ngIf="data.items.length === 0">All employees have correct supervisors </h1>
</div>
<div *ngIf="data.items.length > 0 && !isLoading">
    <div *ngFor="let item of data.items;" style="display: flex;align-items: self-start;padding: 1em; ">
        <p style="margin: 0;
        align-content: center;
        font-size: 0.75em;
        color: #424242;">{{item.display}} <span class="updateText" (click)="fixEmployee(item)" style="
        padding: 0.4em;"> {{ item.updating ? 'Updating...' : 'Update RH' }}</span></p>
    </div>
</div>

<div style="place-items: center;" *ngIf="isLoading">
    <img  width="400px;" src="https://rhassets.s3.us-east-1.amazonaws.com/BambooHR-img-CARD.webp">
    <p style="font-size: 1.25em;
    color: #85c03e;" class="loadingAnimation">
        Comparing data from BambooHR...
        </p>
</div>
